var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Unrecoverable Errors")]),_vm._l((_vm.errors),function(error,i){return _c('div',{key:i,staticClass:"unrecoverable-errors"},[_vm._v(" "+_vm._s(error)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }